<ng-container *ngIf="isCreateMode()">
  <form (ngSubmit)="save()" [formGroup]="form">
    <base-form-header [mode]="mode" createLabel="Créer un engagement"></base-form-header>

    <span style="padding: 5px; font-size: large">Veuillez sélectionner un engagement générique</span>
    <base-form-input
      class="w-full"
      type="autocomplete"
      [items$]="genericEngagements$"
      (autocompleteChange)="genericEngagementAutoCompleteChange($event)"
      displayProperty="displayLabel"
      label="Engagement générique"
      controlName="genericEngagement"
    ></base-form-input>

    <div class="mt-4"></div>
    <base-form-input type="checkbox" label="Engagement interne" controlName="isInternal"></base-form-input>

    <ng-container *ngIf="showsupportEstablishmentField">
      <base-form-input
        class="w-full"
        type="autocomplete"
        [items$]="supportEstablishment$"
        (autocompleteChange)="supportEstablishmentAutoCompleteChange($event)"
        [disabled]="!hasUsersupportEstablishment"
        displayProperty="label"
        label="Établissement support"
        controlName="supportEstablishment"
      ></base-form-input>
    </ng-container>

    <mat-dialog-actions align="end">
      <base-form-input
        [loading]="loading"
        type="submit"
        [mode]="mode"
        entityLabel="ENREGISTRER"
        [disabled]="showsupportEstablishmentField && !hasUsersupportEstablishment"
        [appearance]="'fill'"
        (onCreate)="createItem()"
      ></base-form-input>
    </mat-dialog-actions>
  </form>
</ng-container>
